import { get, post } from './agent';

const microsoftTeamsLinkRequests = (token) => {
  const url = `/www/microsoft/teams/link-requests/${encodeURIComponent(token)}`;

  return {
    get: () => get(url),
    confirm: (body) => post(url, body),
  };
};

export default microsoftTeamsLinkRequests;
